var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUzayCloseIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 117,
    viewBox: "0 0 117 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_1339_4032)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 19,
    width: 75,
    height: 75,
    rx: 37.5,
    transform: "rotate(90 96 19)",
    fill: "#6C5DD3"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 19,
    width: 75,
    height: 75,
    rx: 37.5,
    transform: "rotate(90 96 19)",
    fill: "url(#paint0_linear_1339_4032)",
    style: {
      mixBlendMode: "overlay"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.8053 59.6741L67.6437 68.5124C68.1127 68.9814 68.7487 69.2449 69.412 69.2449C70.0753 69.2449 70.7113 68.9814 71.1803 68.5124C71.6493 68.0434 71.9128 67.4073 71.9128 66.7441C71.9128 66.0808 71.6493 65.4447 71.1803 64.9757L62.3387 56.1374L71.1787 47.2991C71.4108 47.0668 71.5949 46.7912 71.7204 46.4878C71.846 46.1844 71.9106 45.8593 71.9105 45.531C71.9105 45.2026 71.8457 44.8775 71.72 44.5742C71.5943 44.2709 71.41 43.9953 71.1778 43.7632C70.9456 43.5311 70.6699 43.347 70.3666 43.2214C70.0632 43.0959 69.7381 43.0313 69.4097 43.0313C69.0814 43.0314 68.7563 43.0962 68.453 43.2219C68.1497 43.3476 67.8741 43.5318 67.642 43.7641L58.8053 52.6024L49.967 43.7641C49.7365 43.5252 49.4607 43.3346 49.1558 43.2034C48.8508 43.0723 48.5228 43.0031 48.1909 43.0001C47.8589 42.9971 47.5297 43.0602 47.2224 43.1857C46.9151 43.3113 46.6359 43.4968 46.401 43.7314C46.1662 43.966 45.9804 44.2451 45.8546 44.5522C45.7287 44.8594 45.6653 45.1886 45.6681 45.5205C45.6708 45.8525 45.7396 46.1806 45.8705 46.4856C46.0013 46.7907 46.1917 47.0667 46.4303 47.2974L55.272 56.1374L46.432 64.9774C46.1933 65.2081 46.003 65.4841 45.8721 65.7891C45.7413 66.0942 45.6724 66.4223 45.6697 66.7542C45.667 67.0862 45.7304 67.4154 45.8562 67.7225C45.9821 68.0297 46.1679 68.3088 46.4027 68.5434C46.6375 68.778 46.9168 68.9635 47.2241 69.0891C47.5314 69.2146 47.8606 69.2777 48.1925 69.2747C48.5245 69.2716 48.8525 69.2025 49.1574 69.0714C49.4624 68.9402 49.7382 68.7496 49.9687 68.5107L58.8053 59.6741Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_1339_4032",
    x: 0.204155,
    y: 0.28374,
    width: 116.592,
    height: 116.592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07958
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.3979
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1339_4032"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.31834
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.19896
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1339_4032",
    result: "effect2_dropShadow_1339_4032"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.15917
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.15917
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_1339_4032",
    result: "effect3_dropShadow_1339_4032"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_1339_4032",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1339_4032",
    x1: 133.5,
    y1: 19,
    x2: 133.5,
    y2: 94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUzayCloseIcon);
export default __webpack_public_path__ + "static/media/uzayCloseIcon.428911785a9b371fef2da5c2c5e176e4.svg";
export { ForwardRef as ReactComponent };